/**
 * Assistant (chat IA) — contrat entre le widget et `POST /api/chat`.
 *
 * La conversation vit côté navigateur : le widget renvoie à chaque question
 * les derniers échanges (texte seulement), l'API ne garde rien. La réponse est
 * un flux SSE (`text/event-stream`) d'évènements `ChatStreamEvent`, un par
 * ligne `data:`.
 */

export type ChatRole = 'user' | 'assistant';

export interface ChatTurn {
  role: ChatRole;
  content: string;
}

export interface ChatRequest {
  /** Du plus ancien au plus récent ; le dernier est la question, rôle `user`. */
  messages: ChatTurn[];
}

/** Échanges renvoyés au plus par le widget (questions + réponses). */
export const CHAT_MAX_TURNS = 16;
/** Longueur maximale d'un échange, en caractères. */
export const CHAT_MAX_TURN_CHARS = 4000;

export type ChatStreamEvent =
  /** Fragment de la réponse, à concaténer. */
  | { type: 'text'; text: string }
  /** Le modèle interroge la base : la requête et ce qu'il en attend. */
  | { type: 'sql'; sql: string; purpose: string }
  /** Résultat de la requête précédente (lignes renvoyées, ou erreur). */
  | { type: 'sql_result'; rows: number; truncated: boolean; durationMs: number; error?: string }
  /** Fin de la réponse, avec la consommation de jetons de la question. */
  | { type: 'done'; inputTokens: number; outputTokens: number }
  /** Arrêt sur erreur : message à afficher. */
  | { type: 'error'; message: string };
